<template>
  <div class="mainBox">
    <div class="mainCon">
      <div class="stuMainTitle">
        <span class="title">{{ isPassWordExpired === 1 ? '账户设置：您的密码已过期，请重新设置密码': '账户设置' }}</span>
      </div>
      <div class="content">
        <el-form :model="form" class="formStyle" ref="form" :rules="rules">
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="form.realName"></el-input>
          </el-form-item>
          <el-form-item label="证件号">
            <el-input v-model="form.cardNo" disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="form.password" placeholder="请输入密码" auto-complete="new-password"></el-input>
            <ots-password-tooltip></ots-password-tooltip>
          </el-form-item>
          <el-form-item label="确认新密码" prop="confirmPassword">
            <el-input type="password" v-model="form.confirmPassword" auto-complete="new-password"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <stu-foot confirmtext="确定" cancelText="" @confirm="updateUser"></stu-foot>
  </div>
</template>
<script>
import { updateInfoFn } from "@/http/modules/student/userConfig";
import { selectUserInfo } from "@/http/modules/student/ticket";
import stuFoot from "../components/stuFoot.vue";
import { checkPwd, checkPhone, passWordStrength} from "@/common/verify.js";
export default {
  components: { stuFoot },
  name: "userConfig",
  data () {
    return {
      form: {
        realName: "",
        cardNo: "",
        phone: "",
        password: "",
        confirmPassword: "",
        content: "",
      },
      rules: {
        realName: [
          { required: true, message: "请填写考点名称", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请填写密码", trigger: "blur" },
          { validator: passWordStrength, trigger: "blur" },
        ],
        confirmPassword: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: this.confirmPassword, trigger: "blur" },
        ],
      },

      isPassWordExpired: 0,
    };
  },




  
  // 220204199003161268
  created() {
    this.initData();
  },
  mounted() { 
    this.isMustRestPSD();
  },
  methods: {
    isMustRestPSD(){
      let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      this.isPassWordExpired = userInfo.isPassWordExpired;
    },

    confirmPassword(rule, value, callback) {
      if (value) {
        if (this.form.password !== this.form.confirmPassword) {
          callback(new Error("设置密码和确认密码必须相同"))
        } else {
          callback()
        }
      }
      callback()
    },
    async initData() {
      const { data: user } = await selectUserInfo();
      this.form.realName = user.realName;
      this.form.cardNo = user.cardNo;
      this.form.phone = user.phone;
      this.form.id = user.id;
    },
    async updateUser() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          const { code } = await updateInfoFn(this.form);
          if (code == 1) {
            this.$message.success("修改成功");
            // 修改密码成功：将控制 ‘是否必须修改密码’ 的 localStorage 值修改为 0
            let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
            userInfo.isPassWordExpired = 0;
            window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
            let planId = sessionStorage.getItem("planId");

            this.$router.push({ path: "/stuHome/batch" });

            return;
            if (planId) {
              // 修改密码成功：跳转到首页
              this.$router.push({ path: "/stuHome/home" });
            } else {
              this.$router.push({ path: "/stuHome/batch" });
            }
          }
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.mainBox {
  width: 100%;
  min-width: 700pt;
  background-color: #fff;
}
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .content {
    padding-top: 20px;
    display: flex;
    justify-content: center;
    .formStyle {
      width: 360px;
      /deep/ .el-form-item {
        margin-bottom: 22px !important;
      }
      /deep/ .el-input {
        width: 100%;
      }
      /deep/ .el-input .el-input__inner {
        width: 100%;
      }
    }
  }
}
/deep/ .el-table th,
.el-table tr {
  background-color: #ebecff !important;
}

.stuMainTitle {
    font-size: 20px;
    height: 52px;
    line-height: 52px;
    font-weight: bold;
    border-bottom: 1px solid #DADDE6;
}
</style>